import React, { FC, useEffect, useRef, useState } from 'react';
import { CSSTransition } from 'react-transition-group';
import { Typography } from 'antd';
import { Header } from 'components/header';
import { EpLanguageSkill } from 'types/graphql-types';
import styles from './styles.less';

const { Text } = Typography;

type LanguageSkillCellProps = {
  icon?: React.ReactNode;
  glow?: boolean;
} & EpLanguageSkill;

export const LanguageSkillCell: FC<LanguageSkillCellProps> = ({
  name,
  level,
  icon,
  glow,
}) => {
  const [skill, , ...description] = (level || '').split(' ');

  const nodeRef = useRef(null);

  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  return (
    <CSSTransition
      nodeRef={nodeRef}
      in={glow && mounted}
      classNames={{
        enter: styles['glow-enter'],
        enterActive: styles['glow-enter-active'],
      }}
      timeout={30000}
    >
      <div ref={nodeRef} className={styles['language-skill-cell']}>
        <Header level={4} className={styles['header']}>
          {name}
          {icon}
        </Header>
        <Text className={styles['level']}>{skill}</Text>
        <Text className={styles['level-description']}>
          {description.join(' ') || 'Please add your level'}
        </Text>
      </div>
    </CSSTransition>
  );
};
